import { Body1, Chips, UIHeading1 } from '@cian/ui-kit';

import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { type IPikHistoryItem } from './external/models/PikHistoryItem';

import styles from './PikHistory.css';

type PikHistory = {
  chipsOptions: IPikHistoryItem['chipsOption'][];
  activePikHistoryItem: IPikHistoryItem;
  onChange: (value: string[]) => void;
  onView: () => void;
};

export const PikHistory: FC<PikHistory> = ({ chipsOptions, activePikHistoryItem, onChange, onView }) => {
  return (
    <LayoutBlock id="pik-history" title="История компании" onView={onView}>
      <div className={styles['container']}>
        <Chips<string>
          dataTestId="history-chips"
          options={chipsOptions}
          value={[activePikHistoryItem.chipsOption.value]}
          onChange={onChange}
        />
        <div className={styles['content']}>
          <span className={styles['title']} data-testid="history-title">
            {activePikHistoryItem.chipsOption.label}
          </span>
          <div className={styles['main-text-container']} data-testid="history-content">
            <UIHeading1 data-testid="history-content-title">{activePikHistoryItem.title}</UIHeading1>
            <Body1 data-testid="history-content-description">{activePikHistoryItem.description}</Body1>
          </div>
        </div>
      </div>
    </LayoutBlock>
  );
};
